import TaskPaneType from '../store/schema/TaskPaneType';
import { getTaskPaneRunningInstance } from '../utils/taskPaneUtils';
import { mutatorAction } from 'satcheljs';

export default mutatorAction(
    'updatePersistentTaskPaneHostItem',
    function updatePersistentTaskPaneHostItem(hostItemIndex: string) {
        const taskPane = getTaskPaneRunningInstance(TaskPaneType.Persistent);
        taskPane.hostItemIndex = hostItemIndex;
    }
);
